<template>
  <div class="report-topic-chart">
    <div class="chart-heading">
      <strong>题材近30个交易日 K线</strong>
      <span v-if="topic">{{ topic.stocks.length }}只成分股 · 核心及其他标的去重等权</span>
    </div>
    <v-chart v-if="rows.length && visible" :options="options" autoresize class="topic-candles" />
    <div v-else-if="!rows.length" class="chart-placeholder">{{ status === 'pending' ? 'K线正在异步生成，稍后自动更新…' : '暂无可用日线数据' }}</div>
    <div v-else class="chart-placeholder">滚动至此处加载图表</div>
    <div v-if="rows.length" class="chart-caption">已显示{{ rows.length }}个交易日，指数基准1000；缺失行情的股票不参与当日计算。{{ updatedAt ? `行情快照：${updatedAt}` : '' }}</div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'

export default {
  name: 'ReportTopicKline',
  components: { 'v-chart': ECharts },
  props: {
    topic: { type: Object, default: null },
    status: { type: String, default: 'pending' },
    updatedAt: { type: String, default: '' }
  },
  data() {
    return { visible: false, themeColors: {} }
  },
  computed: {
    rows() { return this.topic ? this.topic.kline || [] : [] },
    options() {
      const { text, border, up, down } = this.themeColors
      return {
        animation: false, backgroundColor: 'transparent',
        textStyle: { color: text },
        grid: { left: 52, right: 16, top: 18, bottom: 32 },
        tooltip: { trigger: 'axis', backgroundColor: this.themeColors.background, textStyle: { color: text }, axisPointer: { type: 'cross' } },
        xAxis: { type: 'category', data: this.rows.map(row => row.trade_date), axisLine: { lineStyle: { color: border } }, axisLabel: { color: text, fontSize: 10 } },
        yAxis: { scale: true, axisLabel: { color: text, fontSize: 10 }, splitLine: { lineStyle: { color: border } } },
        series: [{
          name: '题材指数', type: 'candlestick',
          data: this.rows.map(row => [row.open, row.close, row.low, row.high].map(value => Number(Number(value).toFixed(2)))),
          itemStyle: { color: up, color0: down, borderColor: up, borderColor0: down }
        }]
      }
    }
  },
  mounted() {
    this.updateTheme()
    window.addEventListener('site-theme-changed', this.updateTheme)
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.visible = true
          this.observer.disconnect()
        }
      }, { rootMargin: '200px' })
      this.observer.observe(this.$el)
    } else this.visible = true
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    window.removeEventListener('site-theme-changed', this.updateTheme)
  },
  methods: {
    updateTheme() {
      const css = getComputedStyle(this.$el)
      this.themeColors = {
        background: css.getPropertyValue('--bg-card').trim(),
        text: css.getPropertyValue('--text-main').trim(), border: css.getPropertyValue('--border-color').trim(),
        up: css.getPropertyValue('--color-up-color').trim(), down: css.getPropertyValue('--color-down-color').trim()
      }
    }
  }
}
</script>

<style scoped>
.report-topic-chart { margin: 12px 0 24px; padding: 12px; border: 1px solid var(--border-color); border-radius: 8px; background: var(--bg-card); color: var(--text-main); font-size: 0.85rem; }
.chart-heading { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 6px; }
.chart-heading span, .chart-caption { color: var(--text-muted); font-size: 0.75rem; }
.topic-candles { width: 100%; height: 260px; }
.chart-placeholder { height: 260px; display: flex; align-items: center; justify-content: center; color: var(--text-muted); }
@media (max-width: 767px) { .topic-candles, .chart-placeholder { height: 220px; } .report-topic-chart { padding: 8px; } }
</style>
